import React, { useState } from 'react';
import Layout from '../layout/Layout';
import PageTransition from '../components/PageTransition';

// Component Imports
import { AuthDocs } from './AuthDocs';
import { SendMessageDocs } from './SendMessageDocs';
import { GettingStartedDocs } from './GettingStartedDocs';
import { WebhookDocs } from './WebhookDocs';
import { ErrorCodeDocs } from './ErrorCodeDocs';
import Swal from 'sweetalert2';

export default function Docs() {
  const [activeSection, setActiveSection] = useState('getting-started');
  const [searchQuery, setSearchQuery] = useState("");

  const sections = [
    { id: 'getting-started', label: 'Getting Started', icon: 'fas fa-rocket' },
    { id: 'authentication', label: 'Authentication', icon: 'fas fa-lock' },
    { id: 'send-message', label: 'Send Message', icon: 'fas fa-paper-plane' },
    { id: 'webhooks', label: 'Webhooks', icon: 'fas fa-sync' },
    { id: 'error-codes', label: 'Error Codes', icon: 'fas fa-exclamation-triangle' },
  ];

  const filteredSections = sections.filter(s => 
    s.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Layout>
      <PageTransition>
        <div className="row mt-2">
          {/* STICKY SIDE NAVIGATION */}
          <div className="col-md-3 mb-4">
            <div className="card border-0 shadow-sm rounded-4 sticky-top" style={{ top: '20px' }}>
              <div className="card-body p-3">
                <div className="px-3 mb-4">
                  <h6 className="fw-bold text-uppercase small text-primary mb-3">Documentation</h6>
                  <div className="input-group input-group-sm bg-light rounded-3 border-0">
                    <span className="input-group-text bg-transparent border-0"><i className="fas fa-search text-muted"></i></span>
                    <input 
                      type="text" 
                      className="form-control bg-transparent border-0 ps-0" 
                      placeholder="Search docs..." 
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>

                <nav className="nav flex-column">
                  {filteredSections.map(section => (
                    <DocLink 
                      key={section.id}
                      id={section.id} 
                      label={section.label} 
                      icon={section.icon}
                      active={activeSection} 
                      setter={setActiveSection} 
                    />
                  ))}
                </nav>
              </div>
            </div>
          </div>

          {/* CONTENT AREA */}
          <div className="col-md-9">
            <div className="card border-0 shadow-sm rounded-4 p-4 p-md-5 min-vh-100">
              {activeSection === 'getting-started' && <GettingStartedDocs />}
              {activeSection === 'authentication' && <AuthDocs />}
              {activeSection === 'send-message' && <SendMessageDocs />}
              {activeSection === 'webhooks' && <WebhookDocs />}
              {activeSection === 'error-codes' && <ErrorCodeDocs />}
              
              <hr className="my-5 opacity-25" />
              <div className="d-flex justify-content-between align-items-center bg-light p-4 rounded-4">
                <div>
                  <h6 className="fw-bold mb-1">Still need help?</h6>
                  <p className="text-muted small mb-0">Our support team is available 24/7 for technical assistance.</p>
                </div>
                <button className="btn btn-primary rounded-3 px-4">Contact Support</button>
              </div>
            </div>
          </div>
        </div>
      </PageTransition>
    </Layout>
  );
}

function DocLink({ id, label, icon, active, setter }) {
  const isActive = active === id;
  return (
    <button 
      onClick={() => setter(id)}
      className={`nav-link border-0 bg-transparent text-start rounded-3 py-2 px-3 mb-1 d-flex align-items-center transition-all ${
        isActive ? 'bg-primary text-white shadow-sm' : 'text-muted hover-bg-light'
      }`}
    >
      <i className={`${icon} me-3`} style={{ width: '18px', fontSize: '0.9rem' }}></i>
      <span className="small fw-semibold">{label}</span>
      {isActive && <i className="fas fa-chevron-right ms-auto small opacity-50"></i>}
    </button>
  );
}